import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core";
import { withTranslation } from 'react-i18next';

import HeaderKidsStyle from "./HeaderKidsStyle";
import _ from "lodash";

class HeaderKids extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      present: "",
      attendu: "",
      absent: "",
      parti: "",
      tous: "active",
      selectedSection: null,
    };
    this.handleTab = this.handleTab.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleSectionFilter = this.handleSectionFilter.bind(this);
  }

  handleTab(string) {
    switch (string) {
      case "TOUS":
        this.setState({
          tous: "active",
          present: "",
          attendu: "",
          absent: "",
          parti: "",
        });
        break;
      case "PRESENT":
        this.setState({
          tous: "",
          present: "active",
          attendu: "",
          absent: "",
          parti: "",
        });
        break;
      case "ATTENDU":
        this.setState({
          tous: "",
          present: "",
          attendu: "active",
          absent: "",
          parti: "",
        });
        break;
      case "ABSENT":
        this.setState({
          tous: "",
          present: "",
          attendu: "",
          absent: "active",
          parti: "",
        });
        break;
      case "PARTI":
        this.setState({
          tous: "",
          present: "",
          attendu: "",
          absent: "",
          parti: "active",
        });
        break;
    }
  }

  handleFilter(string) {
    this.props.handleFilterButtons(string);
    this.handleTab(string);
  }

  handleSectionFilter(sectionId) {
    this.setState({ selectedSection: sectionId });
    if (this.props.onSectionFilter) {
      this.props.onSectionFilter(sectionId);
    }
  }

  render() {
    const {
      totalNumKids,
      countAbsent,
      countPresent,
      countParti,
      countAttendus,
      classes,
      sections,
      t,
    } = this.props;
    const { selectedSection } = this.state;
    return (
      <>
        <div className="d-flex align-items-center justify-content-center buttons-filters">
          <button
            className={`btn-filter ${this.state.tous}`}
            value="TOUS"
            onClick={() => this.handleFilter("TOUS")}
          >
            {t('dashboard.all')}
          </button>
          <button
            className={`btn-filter ${this.state.present}`}
            value="PRESENT"
            onClick={() => this.handleFilter("PRESENT")}
          >
            {`${countPresent} ${t('dashboard.present')}`}
          </button>
          <button
            className={`btn-filter ${this.state.attendu}`}
            value="ATTENDU"
            onClick={() => this.handleFilter("ATTENDU")}
          >
            {`${countAttendus} ${t('dashboard.expected')}`}
          </button>
          <button
            className={`btn-filter ${this.state.absent}`}
            value="ABSENT"
            onClick={() => this.handleFilter("ABSENT")}
          >
            {`${countAbsent} ${t('dashboard.absent')}`}
          </button>
          <button
            className={`btn-filter ${this.state.parti}`}
            value="PARTI"
            onClick={() => this.handleFilter("PARTI")}
          >
            {`${countParti} ${t('dashboard.left')}`}
          </button>
        </div>
        {!_.isEmpty(sections) && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ marginTop: "8px", paddingBottom: "6px", flexWrap: "wrap", gap: "6px" }}
          >
            <button
              style={{
                border: selectedSection === null ? "2px solid #004cc5" : "1px solid #d0d7e2",
                borderRadius: "20px",
                padding: "5px 14px",
                fontSize: "13px",
                fontWeight: selectedSection === null ? "600" : "400",
                cursor: "pointer",
                backgroundColor: selectedSection === null ? "#eef3fb" : "#fff",
                color: "#004cc5",
                outline: "none",
                transition: "all 0.15s ease",
              }}
              onClick={() => this.handleSectionFilter(null)}
            >
              {t('dashboard.all_sections')}
            </button>
            {sections.map((section) => {
              const isActive = selectedSection === section.id;
              return (
                <button
                  key={section.id}
                  style={{
                    border: isActive ? "2px solid #004cc5" : "1px solid #d0d7e2",
                    borderRadius: "20px",
                    padding: "5px 10px 5px 24px",
                    fontSize: "13px",
                    fontWeight: isActive ? "600" : "400",
                    cursor: "pointer",
                    backgroundColor: isActive ? "#eef3fb" : "#fff",
                    color: "#004cc5",
                    outline: "none",
                    position: "relative",
                    transition: "all 0.15s ease",
                  }}
                  onClick={() => this.handleSectionFilter(section.id)}
                >
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: section.couleur || "#ccc",
                      display: "inline-block",
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      border: "1px solid rgba(0,0,0,0.1)",
                    }}
                  />
                  {section.nom}
                </button>
              );
            })}
          </div>
        )}
      </>
    );
  }
}
HeaderKids.propTypes = {
  handleFilterButtons: PropTypes.func,
  totalNumKids: PropTypes.number,
  countAbsent: PropTypes.number,
  countPresent: PropTypes.number,
  countParti: PropTypes.number,
  countAttendus: PropTypes.number,
  classes: PropTypes.object,
  sections: PropTypes.array,
  onSectionFilter: PropTypes.func,
};

export default withStyles(HeaderKidsStyle)(withTranslation()(HeaderKids));
